<template>
  <b-modal id="errormessage" size="lg" class="modal-backdrop" no-close-on-esc no-close-on-backdrop>
    <template slot="modal-header" class="mx-auto">
      <h5 class="modal-title">Error Message</h5>
    </template>
    <template slot="default">
      <p>
        <span v-html="errorMessage"></span>
      </p>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="adduserbtn" @click="closeMessage()">Ok</b-button>
    </template>
  </b-modal>
</template>


<script>
export default {
  name: "ErrorMessage",
  props: {
    errorMessage: String,
    callbackOnClose: String,
    title: String
  },
  methods: {
    closeMessage: function() {
      if (this.callbackOnClose != "") this.$emit(this.callbackOnClose);
      this.$bvModal.hide("errormessage");
    }
  }
};
</script>



<style scoped>
.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.8em;
  color: white;
  width: 5.2em;
}
</style>
<style>
.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}
</style>
